module OnlineDPR.Application.Client.Template

open Fable.Core
open Fable.React
open Fable.React.Props

open OnlineDPR.Application.Client
open OnlineDPR.Application.Shared
open OnlineDPR.Application.Shared.Translations
open OnlineDPR.Application.Client.Page

[<Emit("CurrentUser")>]
let currentUser : string = jsNative

[<Emit("ChangePasswordLink")>]
let changePasswordLink : string = jsNative

[<Emit("LogoutLink")>]
let logoutLink : string = jsNative

[<Emit("ControlPanelLink")>]
let controlPanelLink : string = jsNative

[<Emit("ControlPanelBwaLink")>]
let controlPanelBwaLink : string = jsNative

[<Emit("ControlPanelDprLink")>]
let controlPanelDprLink : string = jsNative

[<Emit("ImprintLink")>]
let imprintLink : string = jsNative

let private viewEmpty headerMenu sidebarMenu content =
    div [] [content]

let private viewDefault headerMenu sidebarMenu content =
    div [   ClassName "app"
            Id "app"
        ]
        [   header  [    ClassName "header" ]
                    [   div     [ ClassName "header-block header-block-collapse d-lg-none d-xl-none" ]
                                [
                                    button  [   ClassName "collapse-btn"
                                                Id "sidebar-collapse-btn" ]
                                            [   i   [ ClassName "fa fa-bars" ] [] ]
                                ]
                        div     [   ClassName "header-menu" ]
                                    headerMenu
                        div     [   ClassName "header-block header-block-nav" ]
                                [   match System.String.IsNullOrWhiteSpace currentUser with
                                    | true ->   yield span [] []
                                    | false ->  yield ul    [   ClassName "nav-profile" ]
                                                            [   li  [   ClassName "profile dropdown" ]
                                                                    [   a   [   ClassName "nav-link dropdown-toggle"
                                                                                Href "#"
                                                                                Role "button"
                                                                                AriaHasPopup true
                                                                                AriaExpanded false
                                                                                DataToggle "dropdown"
                                                                            ]
                                                                            [ str currentUser ]
                                                                        div [   ClassName "dropdown-menu profile-dropdown-menu" ]
                                                                            [   a   [   Href changePasswordLink
                                                                                        ClassName "dropdown-item" ]
                                                                                    [
                                                                                        i   [   ClassName "fa fa-key icon"] [ ]
                                                                                        span    [ ] [ str CurrentTranslations.Translations.[TranslationKey.UserDropdown_ChangePassword] ]
                                                                                    ]
                                                                                a   [   Href logoutLink
                                                                                        ClassName "dropdown-item"
                                                                                    ]
                                                                                    [
                                                                                        i   [ ClassName "fa fa-power-off icon"] [ ]
                                                                                        span [ ] [ str CurrentTranslations.Translations.[TranslationKey.UserDropdown_Logout] ]
                                                                                    ]
                                                                            ]
                                                                    ]
                                                            ]
                                ]
                    ]
            aside   [   ClassName "sidebar" ]
                    [   div [   ClassName "sidebar-container" ]
                            [   div [   ClassName "sidebar-header" ]
                                    [   div [   ClassName "brand" ] [ ] ]
                                nav [   ClassName "menu"]
                                    [   ul  [   ClassName "sidebar-menu metismenu"
                                                Id "sidebar-menu"]
                                            [   li  [   ClassName (match currentPage with
                                                                    | Page.ControlPanel -> "mm-active"
                                                                    | _ -> "")]
                                                    [   a   [   Href controlPanelLink]
                                                            [   i   [   ClassName "fa fa-home"] []
                                                                str CurrentTranslations.Translations.[TranslationKey.ControlPanel_Title]
                                                            ]
                                                        ul  [   ClassName "sidebar-nav"]
                                                            [   li  [   ClassName (match currentPage with
                                                                                    | Page.ControlPanelBwa -> "mm-active"
                                                                                    | _ -> "")]
                                                                    [   a   [   Href controlPanelBwaLink]
                                                                            [
                                                                                str CurrentTranslations.Translations.[TranslationKey.ControlPanel_Bwa_Title]
                                                                            ]
                                                                    ]
                                                                li  [   ClassName (match currentPage with
                                                                                    | Page.ControlPanelDpr -> "mm-active"
                                                                                    | _ -> "")]
                                                                    [   a   [   Href controlPanelDprLink]
                                                                            [
                                                                                str CurrentTranslations.Translations.[TranslationKey.ControlPanel_Dpr_Title]
                                                                            ]
                                                                    ]
                                                            ]
                                                    ]
                                                sidebarMenu
                                                |> ofList
                                            ]
                                    ]
                            ]
                        footer  [   ClassName "sidebar-footer"  ]
                                [   ul  [   ClassName "sidebar-menu metismenu"
                                            Id "customize-menu" ]
                                        [   li  []  [   a   [ Href imprintLink ]
                                                            [
                                                                i [   ClassName "fa fa-info" ] [ ]
                                                                str CurrentTranslations.Translations.[TranslationKey.Imprint_Title]
                                                            ]
                                                    ]
                                        ]
                                ]
                    ]
            div     [   ClassName "sidebar-overlay"
                        Id "sidebar-overlay"
                    ] []
            div     [   ClassName "sidebar-mobile-menu-handle"
                        Id "sidebar-mobile-menu-handle"
                    ] []
            div     [   ClassName "mobile-menu-handle"
                        Id "mobile-menu-handle"
                    ] []
            content
        ]

let templateView template headerMenu sidebarMenu content =
    match template with
    | Template.Default -> viewDefault headerMenu sidebarMenu content
    | Template.Empty -> viewEmpty headerMenu sidebarMenu content